"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultState = exports.default = void 0;
var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));
var _get = _interopRequireDefault(require("lodash/get"));
var _setWith = _interopRequireDefault(require("lodash/setWith"));
var _reduxActions = require("redux-actions");
var _deepObjectDiff = require("deep-object-diff");
var _FormTypes = require("../actions/types/FormTypes");
var _helper = require("../utils/helper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const defaultState = exports.defaultState = {
  regFields: {}
};
var _default = exports.default = (0, _reduxActions.handleActions)({
  [_FormTypes.SET_ERRORS]: (state, action) => {
    const {
      formName,
      field,
      data
    } = action.payload;
    const getForm = (0, _cloneDeep.default)((0, _get.default)(state, formName, {}));
    const getValue = (0, _cloneDeep.default)((0, _get.default)(getForm, 'syncErrors', {}));
    (0, _setWith.default)(getValue, field, data);
    if ((0, _get.default)(state, `${formName}.syncErrors.${field}`, '') !== data) {
      return {
        ...state,
        [formName]: {
          ...getForm,
          syncErrors: {
            ...getValue
          }
        }
      };
    }
    return {
      ...state
    };
  },
  [_FormTypes.SET_VALUES]: (state, action) => ({
    ...state,
    ...action.payload
  }),
  [_FormTypes.INITIALIZE_FORM]: (state, action) => {
    const {
      formName,
      data
    } = action.payload;
    const getForm = (0, _cloneDeep.default)((0, _get.default)(state, formName, {}));
    return {
      ...state,
      [formName]: {
        ...getForm,
        values: {
          ...data
        },
        initialValues: {
          ...data
        }
      }
    };
  },
  [_FormTypes.CHANGE_VALUE]: (state, action) => {
    const {
      formName,
      field,
      data
    } = action.payload;
    const formValue = state[formName];
    const getValue = (0, _cloneDeep.default)((0, _get.default)(formValue, 'values', {}));
    (0, _setWith.default)(getValue, field, data);
    const changeObj = (0, _deepObjectDiff.diff)((0, _get.default)(state, `${formName}.values.${field}`, ''), data);
    if (typeof data === 'object' && changeObj && Object.keys(changeObj).length > 0 || typeof data !== 'object' && (changeObj || !(0, _helper.isEmptyWithBool)(changeObj) || !data) && (0, _get.default)(state, `${formName}.values.${field}`, '') !== data) {
      return {
        ...state,
        [formName]: {
          ...formValue,
          values: {
            ...getValue
          }
        }
      };
    }
    return {
      ...state
    };
  },
  [_FormTypes.RESET_FORM]: (state, action) => {
    const {
      formName,
      data
    } = action.payload;
    const getForm = (0, _cloneDeep.default)((0, _get.default)(state, formName, {
      values: {},
      initialValues: {}
    }));
    getForm.values = data;
    getForm.initialValues = data;
    return {
      ...state,
      [formName]: {
        ...getForm
      }
    };
  },
  [_FormTypes.DELETE_FORM]: (state, action) => {
    const {
      formName
    } = action.payload;
    const getForm = state || {};
    delete getForm[formName];
    return {
      ...state,
      ...getForm
    };
  },
  [_FormTypes.SET_REGISTERED_FIELDS]: (state, action) => ({
    ...state,
    regFields: action.payload
  })
}, defaultState);